import { fetcher } from "helpers/fetcher";

import { TGetUserAppAccessRightReq, TGetUserAppAccessRightRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getUserAppAccessRight = async (
  payload?: TGetUserAppAccessRightReq
) => {
  return await fetcher<
    TGetUserAppAccessRightRes,
    TGetUserAppAccessRightReq["data"]
  >(ENDPOINT.MANAGEMENT.GET_USER_APP_ACCESS_RIGHT, {
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.MANAGEMENT.GET_USER_APP_ACCESS_RIGHT.version,
      [API_HEADER.BU_ID]: payload?.idBu,
    },
    params: payload?.data,
  });
};

export const queryGetUserAppAccessRight = async (
  payload?: TGetUserAppAccessRightReq
) => {
  return (await getUserAppAccessRight(payload)).data;
};

queryGetUserAppAccessRight._key = (payload?: TGetUserAppAccessRightReq) => [
  ENDPOINT.MANAGEMENT.GET_USER_APP_ACCESS_RIGHT.url,
  payload,
];
